module.exports = __webpack_public_path__ + "static/img/cooperation13.19169f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImgs/cooperation13.png
// module id = BioQ
// module chunks = 11